import { top } from '../const';
import { logMR } from '../util';
import msg from '../message/index';

export const send = (type: string, res?: any) => {
    logMR(`send ${type}`);
    return msg.send(top, type, res);
};

/**
 * 必须返回的 send 方法, 20 秒超时报错, 老机器 iframe 通讯会非常慢
 * @param type
 * @param res
 */
export const sendRe = (type: string, res?: any) => new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
        reject('SMP:MR iframe 通讯超时, 请刷新页面重试, 或平台接待配置异常');
    }, 20000);
    send(type, res).then((res: any) => {
        clearTimeout(timeoutId);
        resolve(res);
    });
});

export default send;
